// 员工管理路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/staffManagement',
  component: Layout,
  children: [
    {
      path: 'marketingsalesman',
      component: () => import('@/view/staffManagement/salesman'),
      name: '员工管理'
    },
    {
      path: 'rolePrivileges',
      component: () => import('@/view/staffManagement/rolePrivileges'),
      name: '角色权限'
    },
    {
      path: 'exportList',
      component: () => import('@/view/staffManagement/exportList'),
      name: '导出列表'
    },
    {
      path: 'relationBind',
      component: () => import('@/view/staffManagement/relationBind'),
      name: '默认佣金设置'
    }
  ]
}
